var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.className,style:(_vm.colorStyle)},[_c('mdicon',{attrs:{"name":_vm.iconName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }